﻿import { TextStyle, Validator } from '../core/annotations.mjs';  
import { h } from './element.mjs'; 
import  svgIcon  from '../icons.mjs';
import { FormInput, Combobox, Checkbox, Button, ToggleButtonGroup, ToggleButton } from './formElement.mjs';
import { usd, frg } from '../lookup.mjs';
/**
 * Class          : FieldEditor
 * Author         : Pratheeshkumar N P
 * Created On     : 24-Apr-2025 
 * Other Fn calls :
 * Comments       :
 * ================================================================================================
 *   Last Modified By  ||    Date        ||    Purpose/Reason
 * ================================================================================================
 */
export default class FieldEditor {
    constructor(outerWrap, update = () => { }, setAlign = () => { }, deleteField = () => { }, loc) {
        this.update = update;
        this.deleteField = deleteField;
        this.loc = loc;
        this.annott = null;
        this.annotts = null;
        this.multiple = false;
        this.format = '';
        this.decimalLen = 2;
        const handleUpdate = (key=null) => {
            if (this.annotts) {
                const {
                    fieldName, format, fieldType, fieldMaxLen, fieldWidth, fieldHeight,
                    fieldLeft, fieldTop, checkReadonly, checkIsReport, checkRequired,
                    checkEditVsl, checkEditOff, dn, fieldStyle, fieldValidation
                } = this;

                const numformat = fieldType.getValue() === 'number' ? format : '';

                this.annotts.forEach(a => {
                    const updatedAnnott = {
                        ...a,
                        ...(a.type !== 'image' && {
                            ...(fieldType.hasSingleValue && { type: fieldType.getValue() }),
                            ...(fieldMaxLen.hasSingleValue && { maxDataLength: fieldMaxLen.getValue() }),
                            ...(checkReadonly.hasSingleValue && { readOnly: checkReadonly.getValue() }),
                            ...(checkIsReport.hasSingleValue && { isReport: checkIsReport.getValue() }),
                            ...(checkRequired.hasSingleValue && { required: checkRequired.getValue() }),
                            ...(checkEditVsl.hasSingleValue && { editableVsl: checkEditVsl.getValue() }),
                            ...(checkEditOff.hasSingleValue && { editableOff: checkEditOff.getValue() }),
                            ...(dn.hasSingleValue && { registerId: dn.getValue() || '-1' }),
                            ...(fieldHeight.hasSingleValue && { height: fieldHeight.getValue() }),
                            ...(fieldType.getValue() === 'number' && { dataFormat: numformat })
                        }),
                        ...(fieldName.hasSingleValue && { name: fieldName.getValue() || a.name }),
                        ...(fieldWidth.hasSingleValue && { width: fieldWidth.getValue() || a.width }),
                        ...(fieldLeft.hasSingleValue && { left: fieldLeft.getValue() || a.left }),
                        ...(fieldTop.hasSingleValue && { top: fieldTop.getValue() || a.top })
                    };

                    updatedAnnott.style.setData(JSON.stringify(fieldStyle.getData()));
                    updatedAnnott.validation.setData(JSON.stringify(fieldValidation.getData()));

                    a.wrapper.updateElement(updatedAnnott);
                });
            }
            
        }
        this.setAlign = setAlign;   
        const handleHAlign = () => {
            const { hAlign } = this;
            this.setAlign(hAlign.getValue(), false);
        }
        const handleVAlign = () => {
            const { vAlign } = this;
            this.setAlign(false, vAlign.getValue());
        }
        this.handleHAlign = handleHAlign;
        this.handleVAlign = handleVAlign;
        this.handleUpdate = handleUpdate;
        this.outerWrap = outerWrap;
        this.editor = h('div', 'd-flex flex-column gap-2 editor-container');
        this.header = h('div', 'd-flex gap-2 align-items-center');
        this.editorWrap = h('div', 'd-flex flex-column gap-2 flex-fill overflowy-scroll');  
        this.fieldSet = h('div', 'd-flex flex-column gap-1 field-set');
        this.fieldName = new FormInput('fieldName', this.loc.t('labels.name'), 'text', this.handleUpdate);
        this.selectAllFields = new Checkbox('checkSelectAll', this.loc.t('checkboxes.selectAll'), false, (e) => {
            if (e.currentTarget.checked && this.page) {
                this.page.selectAllFields();
            }
        }); 
        this.numberFormatWrap = h('div', ''); 
        const fieldTypes = [
            'textbox', 'number', 'date', 'textarea', 'combobox',
            'checkbox',  'matrix'/*'radio', 'submit', 'button', 'signature',*/
        ];

        const fieldTypeOptions = fieldTypes.map(key => ({
            key: key,
            label: this.loc.t(`fieldTypes.${key}`)
        }));
        this.fieldType = new Combobox('fieldType', this.loc.t('labels.type'), '', fieldTypeOptions,
        (s) => {
            if (['combobox', 'checkbox', 'radio'].includes(s)) {
                this.ds.show(); this.dn.show();
            } else {
                this.ds.hide(); this.dn.hide();
            }
            
            if (s === 'number') {
                this.format = '00.00'; 
                this.numberFormatWrap.show();
                this.sample.show();
            } else { 
                this.numberFormatWrap.hide();
                if (['combobox', 'textbox', 'textarea'].includes(s)) {
                    this.format = this.loc.t('sampleTexts.textFormat');
                    this.sample.show();
                }
                else {
                    this.sample.hide();
                    this.format = ''; 
                }
            }
            this.fieldValidation.changedProperties(s);
            this.sampleText.el.innerText = this.format;
            this.fieldType.hasSingleValue = true; 
            this.handleUpdate();
            });

        this.sample = h('div', 'content-sample');  
        this.sampleText = h('div', 'sample');  
        this.sample.child(this.sampleText);
        const createDecimalButton = (symbols) => {
            const span = h('span', 'd-flex flex-column align-items-center');
            symbols.forEach(s => span.child(h('span').child(s).el));
            return span;
        };

        this.btnIncreaseDecimal = new Button(createDecimalButton(['00', '-→']), 'btn btn-light btn-sm');
        this.btnDecreaseDecimal = new Button(createDecimalButton(['00', '←-']), 'btn btn-light btn-sm');
         
        this.numberFormatWrap.children( 
            h('div', 'd-flex gap-1 align-items-center').children(
            this.btnIncreaseDecimal.el,
            this.btnDecreaseDecimal.el)
        );
          
        this.btnIncreaseDecimal.on('click', () => { this.decimalLen++; this.setNumberFormat(); this.handleUpdate(); });
        this.btnDecreaseDecimal.on('click', () => { this.decimalLen--; this.setNumberFormat(); this.handleUpdate(); });

        this.fieldMaxLen = new FormInput('fieldMaxLen', this.loc.t('labels.maxLength'), 'number');
        this.fieldMaxLen.el.addClass('w-50');

        this.fieldWidth = new FormInput('fieldWidth', this.loc.t('labels.width'), 'number', this.handleUpdate);
        this.fieldHeight = new FormInput('fieldHeight', this.loc.t('labels.height'), 'number', this.handleUpdate);
        this.fieldLeft = new FormInput('fieldLeft', this.loc.t('labels.left'), 'number', this.handleUpdate);
        this.fieldTop = new FormInput('fieldTop', this.loc.t('labels.top'), 'number', this.handleUpdate);

        this.hAlign = new ToggleButtonGroup(this.loc.t('titles.horizontalAlign'), [
            { label: this.loc.t('alignment.horizontal.left'), value: 'left', icon: svgIcon.alignLeft },
            { label: this.loc.t('alignment.horizontal.center'), value: 'center', icon: svgIcon.alignCenter },
            { label: this.loc.t('alignment.horizontal.right'), value: 'right', icon: svgIcon.alignRight }
        ], null, false, this.handleHAlign);

        this.vAlign = new ToggleButtonGroup(this.loc.t('titles.verticalAlign'), [
            { label: this.loc.t('alignment.vertical.top'), value: 'top', icon: svgIcon.alignTop },
            { label: this.loc.t('alignment.vertical.middle'), value: 'middle', icon: svgIcon.alignMiddle },
            { label: this.loc.t('alignment.vertical.bottom'), value: 'bottom', icon: svgIcon.alignBottom }
        ], null, true, this.handleVAlign);

        this.sameHeight = new ToggleButton(this.loc.t('buttons.sameHeight'), svgIcon.height, false, () => {
            const h = Math.max(...this.annotts.map(item => item['height'] ?? 0));
            this.fieldHeight.setValue(h);
            this.handleUpdate();
        });
        this.sameWidth = new ToggleButton(this.loc.t('buttons.sameWidth'), svgIcon.width, false, () => {
            const w = Math.max(...this.annotts.map(item => item['width'] ?? 0));
            this.fieldWidth.setValue(w);
            this.handleUpdate();
        });

        this.checkReadonly = new Checkbox('checkReadonly', this.loc.t('checkboxes.readonly'), false, (e) => {
            if (e.target.checked) {
                this.ds.show();
                this.dn.show();
            } else {
                this.ds.hide();
                this.dn.hide();
            }
            this.handleUpdate();
        });
        this.checkIsReport = new Checkbox('checkIsReport', this.loc.t('checkboxes.isReport'), false, this.handleUpdate);
        this.checkPlaceholder = new Checkbox('checkPlaceholder', this.loc.t('checkboxes.placeholder'), false, this.handleUpdate);
        this.checkRequired = new Checkbox('checkRequired', this.loc.t('checkboxes.required'), false, this.handleUpdate);
        this.checkEditOff = new Checkbox('checkEditOff', this.loc.t('checkboxes.office'), false, this.handleUpdate);
        this.checkEditVsl = new Checkbox('checkEditVsl', this.loc.t('checkboxes.vessel'), false, this.handleUpdate);

        this.editAt = h('div', 'pb-1');
        this.editAt.children(
            h('div', 'd-flex flex-row bg-light rounded bg-gradient px-3 py-2 gap-2 align-items-center border').children(
                h('label').child(this.loc.t('titles.editableAt')),
                this.checkEditVsl.el,
                this.checkEditOff.el
            )
        );
        
        const styleWrapper = h('div', 'style-wrapper');
        this.fieldStyle = new StyleEditor(styleWrapper,loc); 

        const validationWrapper = h('div', 'validation-wrapper');
        this.fieldValidation = new ValidationEditor(validationWrapper,loc); 
         
        this.tabContainer = h('div', 'tab-editor-container');  

        const tabNav = h('ul', 'nav nav-tabs');
        const tabContent = h('div', 'tab-content border border-top-0 rounded-bottom p-2 bg-light');
         
        const tabs = [
            { name: this.loc.t('titles.style'), wrapper: styleWrapper },
            { name: this.loc.t('titles.validation'), wrapper: validationWrapper }
        ];


        tabs.forEach(({ name, wrapper }, index) => { 
            const tabId = `tab-${name.toLowerCase()}`;

            const li = h('li', 'nav-item');
            const a = h('a', 'nav-link')
                .attr({ href: `#${tabId}`, role: 'tab', 'data-bs-toggle': 'tab' })
                .html(name)
                .on('click', (e) => {
                    e.preventDefault();
                     
                    tabs.forEach(({ wrapper }, i) => {
                        wrapper.el.classList.toggle('show', i === index);
                        wrapper.el.classList.toggle('active', i === index);
                    });
                     
                    [...tabNav.el.querySelectorAll('.nav-link')].forEach((el, i) => {
                        el.classList.toggle('active', i === index);
                    });
                });

            if (index === 0) a.addClass('active');

            li.child(a);
            tabNav.child(li);
             
            wrapper.el.classList.add('tab-pane', 'fade');
            if (index === 0) wrapper.el.classList.add('show', 'active');
            tabContent.child(wrapper);
        });
         
        this.tabContainer.children(tabNav, tabContent);


        this.datasourceList = [{ 'key': 'frg', 'label': 'From Register' }, { 'key': 'usd', 'label': 'User Defined' }]
        this.datanameList = [];   
        this.ratioBtn = h('button', 'ratio-btn').on('click', (e) => { this.ratioClick.bind(this); }).hide();
        const ds = new Combobox('datasource-combo', this.loc.t('labels.datasource'), '0', this.datasourceList, (it) => { this.datasourceChange(it); this.handleUpdate(); });
        const dn = new Combobox('dataname-combo', this.loc.t('labels.dataname'), '', [], (it) => { this.datanameChange(it); this.handleUpdate(); }); 
        this.ds = ds;
        this.dn = dn;

        this.renderSkeleton();
        this.renderInputs(); 
        this.renderButtons();

        this.sample.hide()
        this.fieldName.hide();
        this.fieldType.hide();
        this.fieldMaxLen.hide();
        this.numberFormatWrap.hide()
        this.fieldWidth.hide();
        this.fieldHeight.hide();
        this.fieldLeft.hide();
        this.fieldTop.hide(); 
        this.checkReadonly.hide();
        this.checkIsReport.hide();
        this.checkPlaceholder.hide();
        this.checkRequired.hide()
        this.editAt.hide();
        this.fieldStyle.hide(); 
        this.dn.hide();
        this.fieldSet.hide();
        this.page = null;
        

    }
    setNumberFormat() {
        this.format = '00';
        if (this.decimalLen > 0) {
            this.format += '.';
            for (let i = 0; i < this.decimalLen; i++) {
                this.format += '0';
            }
        }
        this.sampleText.el.innerText = this.format;
    }
    ratioClick(e) {

    }
    populateLookup(d) {
        d != null && this.dn?.populate(d);
    }
    datasourceChange(key) {
        const data = frg.find(item => item.HARD_CODE === key.toUpperCase()); 
        if (data && data.lstObjectRegister) {
            this.datanameList = data.lstObjectRegister;
            const list = data.lstObjectRegister.map(obj => ({ key: obj.ID, label: obj.NAME }));   
            this.dn.populate(list); 
        }
    }
    datanameChange(key) {  
        const data = this.datanameList.find(item => item.id === key);
        if (data && data.lstObjectRegister) {
            const list = data.lstObjectRegister;
        }
    }

    renderSkeleton() {
        this.outerWrap.appendChild(this.editor.el); 
        const closeBtn = new Button('Close', 'k-button k-button-solid k-rounded-md k-button-md k-button-flat-base');
        closeBtn.on('click', () => { this.hide(); });
        this.header.children(
            h('h6', 'flex-fill').child('Edit Field Properties'),
            closeBtn.el
        );
        this.editor.child(this.header); 
        this.editor.child(this.sample); 
        
    }

    renderInputs() {
        
        this.editorWrap
            .children(
                //this.fieldSet.el,
                h('div', 'd-flex content-justify-end').children(this.selectAllFields.el),
                this.fieldName.el,
                this.fieldType.el,
                h('div', 'd-flex gap-2 align-items-end content-justify-between').children(this.fieldMaxLen.el, this.numberFormatWrap.el),
                h('div', 'd-flex gap-2').children(this.sameHeight.render(), this.fieldHeight.el, this.sameWidth.render(), this.fieldWidth.el), 
                h('div', 'd-flex flex-row gap-2 align-items-center').children(this.fieldLeft.el, this.fieldTop.el),
                h('div', 'd-flex gap-2').children(this.hAlign.render(), this.vAlign.render()),
                this.editAt.el,
                h('div', 'd-flex gap-3 flex-wrap pb-3').children(this.checkReadonly.el, this.checkRequired.el, this.checkIsReport.el ),
                 
                this.dn.el,
                this.tabContainer.el
            );

        this.editor.child(this.editorWrap);
    }
    

    renderButtons() {
        const btnDiv = h('div', 'd-flex align-items-center justify-content-between gap-2 py-2');

        const updateBtn = new Button(this.loc.t('buttons.update'), 'k-button k-button-solid k-rounded-md k-button-md k-button-solid-light');
        const deleteBtn = new Button(this.loc.t('buttons.remove'), 'k-button k-button-solid k-rounded-md k-button-md k-button-outline-base');

        updateBtn.on('click', () => { this.handleUpdate(); this.hide(); });
        deleteBtn.on('click', () => { this.deleteField(); this.hide(); });

        btnDiv.children(deleteBtn.el,updateBtn.el);
        this.editor.child(btnDiv);
    }
     
    setData(page, setAlign = () => { }) {
        const {
            sample, fieldName, fieldType, fieldMaxLen, numberFormatWrap, fieldWidth, fieldHeight,
            fieldLeft, fieldTop, checkReadonly, checkIsReport, checkPlaceholder, checkRequired, checkEditOff, checkEditVsl, editAt,
            fieldStyle, dn, fieldSet, sameHeight, sameWidth, fieldValidation,
            vAlign, hAlign
        } = this;
        this.page = page || null;
        this.deleteField = page?.deleteFields?.bind(page);
        this.setAlign = setAlign; 
        const { selection } = page;
        const annotts = selection._;
        this.annotts = annotts; 

        const isMultiple = annotts?.length > 1;
        this.multiple = isMultiple;

        isMultiple ? fieldName.hide() : fieldName.show();
        //isMultiple ? fieldSet.show().empty() : fieldSet.hide().empty();
        isMultiple ? (sameHeight.show(), sameWidth.show(), vAlign.show(), hAlign.show()) :
            (sameHeight.hide(), sameWidth.hide(), vAlign.hide(), hAlign.hide());

        const [first] = annotts;

        const fieldsDiffer = (key) => {
            const val = first?.[key];
            return annotts.some(item => item[key] !== val);
        };
         
        //annotts.forEach(a => {
        //    const node = h('div', 'node');
        //    const label = h('label').child(a.code);
        //    const removeBtn = h('button').on('click', () => {
        //        selection.remove(a);
        //        node.hide();
        //    });
        //    node.children(label.el, removeBtn.el);
        //    fieldSet.child(node);
        //});
         
        const bindControl = (key, control, defaultValue) => {
            const hasSingleValue = !fieldsDiffer(key);
            control.hasSingleValue = hasSingleValue;

            if (hasSingleValue) {
                const val = first?.[key] ?? defaultValue;
                control.setValue(val).show();
            } else {
                control.multipleValues(true).show(); 
            }
            if (key == 'type') return;

            //if (typeof control.onChange === "function") {
            //    const original = control.onChange; 
            //    control.onChange = function () {
            //        original(s); 
            //        control.hasSingleValue = true;
            //    };
            //} else {
            //    control.hasSingleValue = true;
            //}
            
        };

        if (first.__type === 'Annotation') {
            bindControl('type', fieldType, 'textbox');
            bindControl('maxDataLength', fieldMaxLen, 20);
            bindControl('readOnly', checkReadonly, false);
            bindControl('isReport', checkIsReport, false);
            bindControl('placeholder', checkPlaceholder, '');
            bindControl('required', checkRequired, false);
            bindControl('editableVsl', checkEditVsl, '');
            bindControl('editableOff', checkEditOff, '');
            bindControl('registerId', dn, '-1');
            editAt.show();

            if (!fieldsDiffer('type') && ['combobox', 'checkbox', 'radio'].includes(first.type)) {
                dn.show();
            } else if (!fieldsDiffer('readOnly') && first.readOnly) {
                dn.show();
            } else {
                dn.hide();
            }

            if (!fieldsDiffer('type') && first.type === 'number') {
                this.format = first.dataFormat || '00.00';
                numberFormatWrap.show();
                sample.show();
            } else {
                numberFormatWrap.hide();
                if (!fieldsDiffer('type') && ['combobox', 'textbox', 'textarea'].includes(first.type)) {
                    this.format = this.loc.t('sampleTexts.textFormat');
                    sample.show();
                } else {
                    sample.hide();
                    this.format = '';
                }
            }

            this.sampleText.el.innerText = this.format;
        }

        bindControl('name', fieldName, '');
        bindControl('left', fieldLeft, 0);
        bindControl('top', fieldTop, 0);
        bindControl('width', fieldWidth, 0);
        bindControl('height', fieldHeight, 0);

        fieldStyle.setData(annotts);
        fieldValidation.setData(annotts);
    }



        
    hide() {
        const { fieldName, fieldType, fieldWidth, fieldHeight, fieldLeft, fieldTop, checkReadonly, checkIsReport, checkPlaceholder, fieldStyle, dn, selectAllFields } = this;
        fieldName.hide(); fieldType.hide(); fieldWidth.hide(); fieldHeight.hide();
        fieldLeft.hide(); fieldTop.hide(); checkReadonly.hide(); checkIsReport.hide(); checkPlaceholder.hide();
        fieldStyle.hide(); dn.hide();
        this.editor.removeClass('d-flex');
        this.editor.addClass('d-none'); 
        if (this.page) {
            this.page = null;
        }
        selectAllFields.setValue(false);

        this.outerWrap.classList.remove('d-flex');
        this.outerWrap.classList.add('d-none');
    }

    show() {
        this.editor.addClass('d-flex');
        this.editor.removeClass('d-none'); 

        this.outerWrap.classList.remove('d-none');
        this.outerWrap.classList.add('d-flex'); 
    }
}
class StyleEditor {
    constructor(outerWrap, loc) {
        this.loc = loc;
        this.outerWrap = outerWrap;
        this.textStyle = new TextStyle();
         
        this.editor = h('div', 'd-flex flex-column gap-2 style-editor-container');
         
        this.fontSize = new FormInput('fontSize', this.loc.t('labels.fontSize'), 'text');
        this.fontFamily = new Combobox('fontFamily', this.loc.t('labels.fontFamily')); //new FormInput('fontFamily', this.loc.t('labels.fontFamily'), 'text');
        this.lineHeight = new FormInput('lineHeight', this.loc.t('labels.lineHeight'), 'text');
        this.color = new FormInput('color', this.loc.t('labels.fontColor'), 'color');
        this.backgroundColor = new FormInput('backgroundColor', this.loc.t('labels.backgroundColor'), 'color');
        this.color.el.value = "#ffffff";  
        this.backgroundColor.el.value = "#ffffff";

        this.fontFamily.populate([
            { key: 'Arial, sans-serif', label: 'Arial, sans-serif' },
            { key: 'Times New Roman', label: 'Times New Roman' },
            { key: 'Courier New', label: 'Courier New' },
            { key: 'Georgia', label: 'Georgia' },
            { key: 'Verdana', label: 'Verdana' },
            { key: 'Tahoma', label: 'Tahoma' },
            { key: 'Trebuchet MS', label: 'Trebuchet MS' },
            { key: 'Comic Sans MS', label: 'Comic Sans MS' },
            { key: 'Impact', label: 'Impact' },
            { key: 'Lucida Console', label: 'Lucida Console' }
        ]);


        this.render();
        outerWrap.child(this.editor);

         
    }

    render() {
        const { fontSize, fontFamily, lineHeight, color, backgroundColor } = this;

        this.editor.children(
            h('div', 'd-flex gap-2').children(fontSize.el, lineHeight.el),
            fontFamily.el, 
            h('div', 'd-flex gap-2').children(color.el)
        );
        return this.editor.el;
    }
     
    setData(annotts) {
        try {   
            const [first] = annotts;
            const style = first.style?.toStyleObject();
            if (style) {
                const { fontSize, fontFamily, lineHeight, color, backgroundColor } = style;

                this.fontSize.setValue(fontSize);
                this.fontFamily.setValue(fontFamily);
                this.lineHeight.setValue(lineHeight);
                this.color.setValue(color);
                this.backgroundColor.setValue(backgroundColor);
                const fieldsDiffer = (key) => {
                    const val = annotts[0]?.[key];
                    return annotts.some(item => item[key] !== val);
                };

                if (annotts.length > 1) {
                    fieldsDiffer('fontSize') ? this.fontSize.multipleValues(true) : this.fontSize.multipleValues(false);
                    fieldsDiffer('fontFamily') ? this.fontFamily.multipleValues(true) : this.fontFamily.multipleValues(false);
                    fieldsDiffer('lineHeight') ? this.lineHeight.multipleValues(true) : this.lineHeight.multipleValues(false);
                    fieldsDiffer('color') ? this.color.multipleValues(true) : this.color.multipleValues(false);
                    fieldsDiffer('backgroundColor') ? this.backgroundColor.multipleValues(true) : this.backgroundColor.multipleValues(false);
                } else {
                    this.fontSize.multipleValues(false);
                    this.fontFamily.multipleValues(false);
                    this.lineHeight.multipleValues(false);
                    this.color.multipleValues(false);
                    this.backgroundColor.multipleValues(false);
                }
                this.show();
            }
            else {
                this.hide();
            }

        } catch (e) {
            console.error('Failed to set style editor data:', e);
             
        }
    }
     
    getData() {
        return {
            fontSize: this.fontSize.getValue(),
            fontFamily: this.fontFamily.getValue(),
            lineHeight: this.lineHeight.getValue(),
            color: this.color.getValue(),
            backgroundColor: this.backgroundColor.getValue()
        } 
    } 
    hide() { 
        this.editor.removeClass('d-flex');
        this.editor.addClass('d-none');
        
    }

    show() {
        this.editor.addClass('d-flex');
        this.editor.removeClass('d-none');
    }
}

class ValidationEditor {
    constructor(outerWrap, loc) {
        this.loc = loc;
        this.outerWrap = outerWrap; 

        this.editor = h('div', 'd-flex flex-column gap-2 validation-editor-container');
        this.minDate = new FormInput('minDate', this.loc.t('labels.minDate'), 'date');
        this.maxDate = new FormInput('maxDate', this.loc.t('labels.maxDate'), 'date'); 
        //this.required = new Checkbox('required', this.loc.t('checkboxes.required'));
        this.operator = new Combobox('operator', this.loc.t('labels.operator'));
        this.value = new FormInput('value', this.loc.t('labels.value'), 'text');
        this.type = new Combobox('type', this.loc.t('labels.type'),'',[], (typeVal) => {
            const isDate = typeVal === 'date';
            if (typeVal === 'date') {
                this.value.hide(); this.operator.hide();
                this.minDate.show();
                this.maxDate.show();
            } else if (typeVal === 'email' || typeVal === 'phone') {
                this.value.hide(); this.operator.hide();
                this.minDate.hide();
                this.maxDate.hide();
            } else {
                this.value.show(); this.operator.show();
                this.minDate.hide();
                this.maxDate.hide();
            }
        });
        this.msg = new FormInput('msg', this.loc.t('labels.message'), 'text');

        this.operator.populate([
            { key: 'eq', label: this.loc.t('validationOperators.eq') },
            { key: 'neq', label: this.loc.t('validationOperators.neq') },
            { key: 'lt', label: this.loc.t('validationOperators.lt') },
            { key: 'lte', label: this.loc.t('validationOperators.lte') },
            { key: 'gt', label: this.loc.t('validationOperators.gt') },
            { key: 'gte', label: this.loc.t('validationOperators.gte') },
            //{ key: 'be', label: this.loc.t('validationOperators.be') },
            //{ key: 'nbe', label: this.loc.t('validationOperators.nbe') },
        ]);

        this.type.populate([
            //{ key: 'text', label: this.loc.t('validationTypes.text') },
            //{ key: 'number', label: this.loc.t('validationTypes.number') },
            //{ key: 'date', label: this.loc.t('validationTypes.date') },
            { key: 'email', label: this.loc.t('validationTypes.email') },
            { key: 'phone', label: this.loc.t('validationTypes.phone') }, 
        ]);
         
        this.render();
        outerWrap.child(this.editor);
    }

    render() {
        this.editor.children(
            //this.required.el, 
            this.type.el,
            this.operator.el, 
            this.minDate.el, 
            this.maxDate.el,
            this.value.el,
            this.msg.el, 
        );
        this.minDate.hide();
        this.maxDate.hide();
    }

    setData(annotts) {
        try {
            const [first] = annotts;
            const validator = first?.validation;
            if (!validator) {
                this.hide();
                return;
            }

            const fieldsDiffer = (key) => {
                const val = first.validation?.[key];
                return annotts.some(a => a.validation?.[key] !== val);
            };
             
            //this.required.setValue(validator.required);
            this.operator.setValue(validator.operator || '');
            this.value.setValue(validator.value || '');
            this.type.setValue(validator.type || '');
            this.msg.setValue(validator.msg || '');
            this.minDate.setValue(validator.minDate || '');
            this.maxDate.setValue(validator.maxDate || '');

            const fields = ['operator', 'value', 'type', 'msg', 'minDate', 'maxDate'];
            if (annotts.length > 1) {
                for (const field of fields) {
                    this[field].multipleValues(fieldsDiffer(field));
                }
            } else {
                for (const field of fields) {
                    this[field].multipleValues(false);
                }
            }

            const annotationType = first?.type;

            if (annotationType === 'date') {
                this.minDate.show();
                this.maxDate.show();
                this.type.hide();  
                this.operator.hide();
            } else if (annotationType === 'textbox' || annotationType === 'number' || annotationType === 'textarea') {
                this.minDate.hide();
                this.maxDate.hide();
                this.type.show();
                this.operator.show();
            } else { 
                this.minDate.hide();
                this.maxDate.hide();
                this.type.hide();
                this.operator.show();
                this.value.show();
            }

            if (!validator.type || validator.type == '-1') {
                this.value.show();
                this.operator.show();
            } else {
                this.value.hide();
                this.operator.hide();
            }

            this.show();
        } catch (e) {
            console.error('Failed to set validation editor data:', e);
        }
    }

    changedProperties(type) {
        try {
              
            const annotationType = type;

            if (annotationType === 'date') {
                this.minDate.show();
                this.maxDate.show();
                this.type.hide();
                this.operator.hide();
                this.value.hide();
            } else if (annotationType === 'textbox' || annotationType === 'number' || annotationType === 'textarea') {
                this.minDate.hide();
                this.maxDate.hide();
                this.type.show();
                this.operator.show();
                this.value.show();
            } else {
                this.minDate.hide();
                this.maxDate.hide();
                this.type.hide();
                this.operator.show();
                this.value.show();
            }

            this.show();
        } catch (e) {
            console.error('Failed to set validation editor data:', e);
        }
    }

    getData() {
        const value = this.value.getValue();
        const operator = this.operator.getValue();
        const type = this.type.getValue();
        return {
            //required: this.required.getValue(),
            operator,
            value,
            type,
            msg: this.msg.getValue(), 
            minDate: this.minDate.getValue(),
            maxDate: this.maxDate.getValue() 
        };
    }

    hide() {
        this.editor.addClass('d-none');
        this.editor.removeClass('d-flex');
    }

    show() {
        this.editor.removeClass('d-none');
        this.editor.addClass('d-flex');
    }
}

 


